var React = require('react');

function Help (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"x":"0.950195","y":"0.75","width":"18.5","height":"18.5","rx":"9.25","stroke":"currentColor","strokeWidth":"1.5","key":0}),React.createElement("path",{"d":"M8.6142 13.89C8.6142 14.576 9.1462 15.08 9.8322 15.08C10.5182 15.08 11.0642 14.576 11.0642 13.89C11.0642 13.204 10.5182 12.686 9.8322 12.686C9.1462 12.686 8.6142 13.204 8.6142 13.89ZM8.9642 7.534C9.0062 7.128 9.3562 6.68 9.9722 6.68C10.5742 6.68 10.9802 7.03 10.9802 7.548C10.9802 8.654 8.7402 8.976 8.7402 10.782C8.7402 11.566 9.2302 12.126 9.3842 12.308L10.7982 11.328C10.6722 11.202 10.5602 11.062 10.5602 10.824C10.5602 9.984 12.8002 9.578 12.8002 7.52C12.8002 6.078 11.5542 5 9.9722 5C8.4462 5 7.4522 5.966 7.2002 7.072L8.9642 7.534Z","fill":"currentColor","key":1})]);
}

Help.defaultProps = {"width":"21","height":"20","viewBox":"0 0 21 20","fill":"none"};

module.exports = Help;

Help.default = Help;
